import { useAppSelector } from '@/redux/store'
import routesPath from '@/utils/routesPath'
import Cookies from 'js-cookie'
import { Navigate, Outlet } from 'react-router-dom'

const { LOGIN } = routesPath

const IsAuthenticated = () => {
  const { token } = useAppSelector((state) => state.auth)
  const accessToken = Cookies.get('token')

  if (!(accessToken && token)) {
    // not logged in so redirect to login page with the return url
    return <Navigate to={LOGIN} />
  }

  return <Outlet />
}

export default IsAuthenticated
